<template>
  <el-dialog :before-close="noDialog" :fullscreen="dialogFullscreen" :visible.sync="dialog" title="新建维修人员">
    <el-form ref="ruleForm" :model="dividend" :rules="rules" label-width="auto">
      <el-form-item label="姓名" prop="nickName">
        <el-input v-model="dividend.nickName"/>
      </el-form-item>
      <el-form-item label="账号" prop="account">
        <el-input v-model.number="dividend.account"/>
      </el-form-item>
      <el-form-item label="密码" prop="pwd">
        <el-input v-model="dividend.pwd" show-password/>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button @click="noDialog">取 消</el-button>
      <el-button type="primary" @click="addDividend">提交</el-button>
    </div>
  </el-dialog>
</template>

<script>
import dialogMixin from "@/mixin/dialogMixin";
import resDisposeMixin from "@/mixin/resDisposeMixin";
import {pwd} from "@/utils/check";
import agentAddMaintenanceMan from "@/api/user/maintenance-man-controler/agentAddMaintenanceMan";

export default {
  name: "addmaintenanceDialog",
  mixins: [dialogMixin, resDisposeMixin],
  data() {
    return {
      rules: {
        nickName: [
          {required: true, message: '请输入分润方姓名', trigger: 'blur'},
        ],
        pwd: pwd,
      },
      dividend: {
        nickName: undefined,
        account: undefined,
        pwd: undefined,
      },
    }
  },
  methods: {
    addDividend() {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          agentAddMaintenanceMan(this.dividend).then(res => {
            this.resEditNoDialog({res, form: 'ruleForm'})
          })
        }
      });
    },
  }
}
</script>
